// extracted by mini-css-extract-plugin
module.exports = {"headerTab":"HeaderTab_headerTab__ELABm","headerTabSelected":"HeaderTab_headerTabSelected__AHQI_","count":"HeaderTab_count__qxfmi","title":"HeaderTab_title__wbXJC"};